import './PwaBanner.sass';

import React, { FC, useCallback, useEffect, useRef } from 'react';
import { useDesktop, useTranslator } from '$hooks';
import { IcClose16, IcDownload28 } from '$assets';
import { mainActions, mainSelector } from '$store/main';
import {
  canInstallPWA,
  classNames,
  isIOS,
  isPWA,
  setStorageItem,
  statReachGoal,
} from '$utils';
import { initPush } from '$services';
import { useDispatch, useSelector } from 'react-redux';
import router from '$navigation/router';
import { PWA_IOS } from '$shared/constants/pages';
import { PwaModal } from '$core';

export const PwaBanner: FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const isDesktop = useDesktop();
  const dispatch = useDispatch();
  const t = useTranslator();
  const { popup } = useSelector(mainSelector);

  useEffect(
    () => () => {
      document.body.style.setProperty('--pwa-banner-height', '0px');
    },
    [],
  );

  useEffect(() => {
    if (ref.current) {
      document.body.style.setProperty(
        '--pwa-banner-height',
        `${ref.current.clientHeight}px`,
      );
    }
  }, [ref]);

  const handleClose = useCallback((e) => {
    e.stopPropagation();
    dispatch(mainActions.setShowInstallPrompt(false));
    setStorageItem('skipPwaBanner', 'true');
  }, []);

  const handleInstall = useCallback(() => {
    statReachGoal('install_pwa_click');
    if (canInstallPWA()) {
      // @ts-ignore
      const deferredPrompt = window.beforeInstallPrompt;
      if (!deferredPrompt) {
        dispatch(mainActions.setShowInstallPrompt(false));
        return;
      }

      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
          statReachGoal('push_notify_enable');
          initPush(dispatch);
        } else {
          console.log('User dismissed the A2HS prompt');
        }

        // @ts-ignore
        window.beforeInstallPrompt = null;
        setStorageItem('skipPwaBanner', 'true');
        dispatch(mainActions.setShowInstallPrompt(false));
      });
    } else {
      if (isIOS()) {
        dispatch(mainActions.setPopup(<PwaModal />));
      } else {
        router.navigate(PWA_IOS);
      }
      //dispatch(mainActions.setShowInstallPrompt(false));
      //setStorageItem('skipPwaBanner', 'true');
    }
  }, []);

  if (isDesktop || isPWA()) {
    return null;
  }

  return (
    <div
      className={classNames({
        PwaBanner: true,
        inactive: !!popup,
      })}
      ref={ref}
      onClick={handleInstall}
    >
      <div className="PwaBanner__close" onClick={handleClose}>
        <IcClose16 />
      </div>
      <div className="PwaBanner__content">
        <div className="PwaBanner__content__title">{t('pwa_banner_title')}</div>
        <div className="PwaBanner__content__caption">{t('pwa_banner_caption')}</div>
      </div>
      <div className="PwaBanner__installButton">
        <IcDownload28 />
      </div>
    </div>
  );
};
